export const FETCH_LOAD_ALL_THERMIT_DATA_REQUEST = 'FETCH_LOAD_ALL_THERMIT_DATA_REQUEST'
export const FETCH_LOAD_ALL_THERMIT_DATA_SUCCESS = 'FETCH_LOAD_ALL_THERMIT_DATA_SUCCESS'
export const FETCH_LOAD_ALL_THERMIT_DATA_FALUIRE = 'FETCH_LOAD_ALL_THERMIT_DATA_FALUIRE'
export const FETCH_LOAD_ALL_THERMIT_FORMATTED_DATA = 'FETCH_LOAD_ALL_THERMIT_FORMATTED'
